import axios, { AxiosPromise } from 'axios';

export interface IcisStaty {
    value: string;
    labelcz: string;
    labelczlong: string;
    labelen: string;
    labelenlong: string;
}

export interface ISezStatu {
    cisStaty: IcisStaty[];
}

const cisStatyApi = (): AxiosPromise<IcisStaty[]> => {
    return axios({
        method: 'GET',
        url: '/Ciselnik/CisStaty'
    });
};

export default cisStatyApi;
